import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsModuleConfig } from '@softapps/core';
import { provideTranslation } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import {
  MdeInventoryModuleConfig,
  SOFTLINE_CONFIG_MDE_INVENTORY,
} from './inventory.shared';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideMdeInventoryModule (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideMdeInventoryGlobals(
  config?: MdeInventoryModuleConfig
): Array<Provider | EnvironmentProviders> {
  return [
    {
      provide: SOFTLINE_CONFIG_MDE_INVENTORY,
      useValue: config ?? {
        showConfirmationOnFinalize: false,
      },
    },
    provideSoftAppsModuleConfig('Inventur', SOFTLINE_CONFIG_MDE_INVENTORY),
    provideTranslation({
      module: 'mdeInventur',
      language: 'de',
      translations: de,
    }),
  ];
}
